import React from 'react';
import withIcon from '../utilities/withIcon';

const IconMobile = () => {
  return (
    <g>
      <path d="m4.05 0 7.902.017A1.05 1.05 0 0 1 13 1.067V14.95c0 .58-.47 1.05-1.05 1.05h-7.9C3.47 16 3 15.53 3 14.95V1.05C3 .47 3.47 0 4.05 0zm7.45 12h-7v2.5h7V12zm-2.75.5a.75.75 0 1 1 0 1.5h-1.5a.75.75 0 1 1 0-1.5h1.5zM11.5 4h-7v6.5h7V4zM4.5 1.5V2.5h7v-.985l-7-.014z" />
    </g>
  );
};

export default withIcon(IconMobile);
